// extracted by mini-css-extract-plugin
export default {"cityCard":"CitySelector_cityCard__7X9aI"};